import { styled as styledMui, Box } from "@mui/material";

export const TabsContainer = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "32px",
  borderBottom: `1px solid ${theme.palette.divider}`,
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    overflowX: "auto",
    overflowY: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export const TabButton = styledMui(Box)<{
  active?: boolean;
  disabled?: boolean;
}>(({ theme, active, disabled }) => ({
  position: "relative",
  padding: "12px 4px",
  cursor: disabled ? "not-allowed" : "pointer",
  fontSize: "14px",
  fontWeight: active ? 700 : 500,
  color: active
    ? theme.palette.primary.main
    : disabled
      ? theme.palette.text.disabled
      : theme.palette.text.primary,
  opacity: disabled ? 0.5 : 1,
  transition: "color 0.15s ease",
  whiteSpace: "nowrap",
  "&::after": active
    ? {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "-1px",
        height: "2px",
        backgroundColor: theme.palette.primary.main,
      }
    : {},
  "&:hover": disabled
    ? {}
    : {
        color: active ? theme.palette.primary.main : theme.palette.text.primary,
      },
}));
